/* Keyboard activation for North's custom filter control. */
document.addEventListener('keydown', (event) => {
  if (event.target.matches('facets-toggle[role="button"]') && ['Enter', ' '].includes(event.key)) {
    event.preventDefault();
    event.target.click();
  }
});
